import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';

const StyledButton = styled(Button)({
  fontSize: '0.875rem',
  fontWeight: 600,
  fontFamily: 'Poppins, sans-serif',
  height: '3.5rem !important',
  minHeight: '3.5rem !important',
  padding: '0 2rem',
  borderRadius: '0.75rem !important',
  width: '100%',
  display: 'block',
});

interface OnboardingActionButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  color?: 'primary' | 'secondary';
}

const OnboardingActionButton: React.FC<OnboardingActionButtonProps> = ({
  children,
  onClick,
  disabled = false,
  color = 'primary',
}) => {
  return (
    <StyledButton
      variant="contained"
      color={color}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </StyledButton>
  );
};

export default OnboardingActionButton; 